import type { ComponentInternalInstance, InjectionKey, Ref } from "vue";

export type ErrorCode = 404 | 403;

export const raiseErrorKey = Symbol() as InjectionKey<(code: ErrorCode) => void>;
export const lastErrorKey = Symbol() as InjectionKey<Readonly<Ref<ErrorCode | undefined>>>;
export const twoColumnLayoutToggleLeftKey = Symbol() as InjectionKey<() => void>;

export type ParentChildRegistryContext = {
  registerItem: (item: ComponentInternalInstance) => void;
  unregisterItem: (item: ComponentInternalInstance) => void;
};

export const parentChildRegistryKey = Symbol() as InjectionKey<ParentChildRegistryContext>;
